import React from "react";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";

const InputLot = ({ onChange, numlots }) => {
  return (
    <TextField
      fullWidth
      label="Agregar lotes"
      type="number"
      value={numlots}
      onChange={e => {
        e.preventDefault();
        onChange(e.target.value);
      }}
      InputLabelProps={{ shrink: true }}
      inputProps={{ min: 0 }}
    />
  );
};

InputLot.propTypes = {
  onChange: PropTypes.func,
  numlots: PropTypes.number
};

export default InputLot;
